import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Label from '../../components/form/labels/Label';
import COMPANY_LOGO from "../../assets/images/logos/logo.png";
import { isEmptyObject } from '../../utils/validators/validators';
import { useDispatch } from 'react-redux';
import { reset, resetPassword } from '../../redux/slice/auth/authSlice';
import { flashMessage } from '../../utils/flash';
import { useSelector } from 'react-redux';

const ResetPassword = () => {
    const [userInput, setUserInput] = useState({
        password: "",
        confirm_password: "",
    });
    const [error, setError] = useState({});

    const { user, isLoading, isError, resetSuccess, message, changePassword } = useSelector(
        (state) => state.auth
    );

    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const passwordRef = useRef(null);
    const confirmPasswordRef = useRef(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserInput((prev) => ({ ...prev, [name]: value }));
        setError((prev) => ({ ...prev, [name]: "" }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError({}); // Clear previous errors
    
        let errors = {}; // Use a local variable instead
    
        if (userInput.password !== userInput.confirm_password) {
            errors.confirm_password = "Passwords do not match";
        }
    
        if (Object.keys(errors).length > 0) {
            setError(errors);
            return;
        }
        
        let credentials = { password: userInput.password, password_confirmation: userInput.confirm_password, staff_id: location.state.staff_id};
        dispatch(resetPassword(credentials));
          
    };

    const togglePasswordVisibility = (ref, iconClass) => {
        if (ref.current) {
            let type = ref.current.getAttribute("type");
            ref.current.setAttribute("type", type === "password" ? "text" : "password");
            document.querySelector(iconClass).classList.toggle("mdi-eye-off");
        }
    };

    useEffect(() => {        
        if (resetSuccess) {
          setUserInput({ ...userInput, password: "", confirm_password: "" });
          navigate("/", { replace: true });
          dispatch(reset());
        }
        if (isLoading) {
          flashMessage("loading", "Reseting password");
        }
        if (isError) {
          setUserInput({ ...userInput, password: "", confirm_password: "" });
          // flash('error', message)
        }
    }, [isLoading, isError, changePassword, resetSuccess, dispatch, userInput, navigate]);  

    return (
        <div className='loading authentication-bg'>
            <div className='account-pages pt-2 pt-sm-5 pb-4 pb-sm-5'>
                <div className='login-bg-divider'></div>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-xxl-4 col-lg-5'>
                            <div className='card'>
                                <div className='card-header pt-2 pb-2 text-center bg-white'>
                                    <Link to='/'>
                                        <img src={COMPANY_LOGO} alt='Company Logo' height='100' />
                                    </Link>
                                    <h4 className='text-warning text-uppercase m-2'>PRUDENT CHOICE</h4>
                                    <h4 className='text-capitalize text-black'>Reset Password</h4>
                                    <span className='badge badge-danger-lighten'>You are required to change your password</span>
                                </div>
                                <div className='card-body p-4'>
                                    <form onSubmit={handleSubmit}>
                                        <div className='mb-3'>
                                            <Label htmlFor='password' labelName='Password' />
                                            <div className='input-group input-group-merge'>
                                                <input
                                                    name='password'
                                                    onChange={handleChange}
                                                    value={userInput.password}
                                                    placeholder='Enter your password'
                                                    type='password'
                                                    className={`form-control ${error.password ? "is-invalid" : ""}`}
                                                    id='password'
                                                    required
                                                    ref={passwordRef}
                                                />
                                                <div className='input-group-text'>
                                                    <span
                                                        className='password-icon mdi mdi-eye'
                                                        onClick={() => togglePasswordVisibility(passwordRef, ".password-icon")}
                                                    ></span>
                                                </div>
                                                <span className='invalid-feedback'>{error.password}</span>
                                            </div>
                                        </div>
                                        <div className='mb-3'>
                                            <Label htmlFor='confirm_password' labelName='Repeat Password' />
                                            <div className='input-group input-group-merge'>
                                                <input
                                                    name='confirm_password'
                                                    onChange={handleChange}
                                                    value={userInput.confirm_password}
                                                    placeholder='Repeat your password'
                                                    type='password'
                                                    className={`form-control ${error.confirm_password ? "is-invalid" : ""}`}
                                                    id='confirm_password'
                                                    required
                                                    ref={confirmPasswordRef}
                                                />
                                                <div className='input-group-text'>
                                                    <span
                                                        className='password-icon2 mdi mdi-eye'
                                                        onClick={() => togglePasswordVisibility(confirmPasswordRef, ".password-icon2")}
                                                    ></span>
                                                </div>
                                                <span className='invalid-feedback'>{error.confirm_password}</span>
                                            </div>
                                        </div>
                                        <div className='mb-3 mb-0 text-center'>
                                            <button
                                                type='submit'
                                                disabled={isLoading}
                                                className='btn w-100 btn-primary fs-5'
                                            >
                                                Reset
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
